import './styles.scss';

const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

const HighlightText = ({ text, query }) => {
  if (!query) return text;
  
  const escapedQuery = escapeRegExp(query);
  const regex = new RegExp(`(${escapedQuery})`, 'gi');
  const parts = text.split(regex);
  
  return parts.map((part, index) =>
    regex.test(part) ? <mark key={index}>{part}</mark> : part
  );
};

export default function Suggestions({ query = "", suggestions = [], id, handleClick }) {
  return (
    <div className="suggestions">
      {suggestions.map((item, index) => (
        <div key={index} className="suggestions__item" onClick={() => handleClick(item.id)}>
          <HighlightText 
            text={item.text} 
            query={query} 
          />
        </div>
      ))}
    </div>
  );
}